/**
 * Utilidades para manejo de URLs de imágenes
 * Nota: La transformación de imágenes de Supabase requiere habilitación adicional
 * Por ahora retornamos las URLs originales para evitar imágenes rotas
 */

/**
 * Retorna la URL de imagen original
 */
export const getOptimizedImageUrl = (
  url: string,
  _width: number = 400,
  _quality: number = 80,
  _format: "webp" | "origin" = "webp"
): string => url || "";

/**
 * Genera URL de thumbnail para cards de productos (600×600)
 */
export const getProductThumbnail = (url: string): string => url || "";

/**
 * Genera URL de imagen para vista de detalle (1200px)
 */
export const getProductDetailImage = (url: string): string => url || "";

/**
 * Genera URL de thumbnail pequeño para listas/órdenes (150×150)
 */
export const getSmallThumbnail = (url: string): string => url || "";

/**
 * Genera URL de imagen para hero/banner (1600px)
 */
export const getHeroImage = (url: string): string => url || "";
